
define(
	'Code25.CaterpartsGlobal.PartsBook'
,   [
		"Handlebars","Utils",'Code25.CaterpartsGlobal.PartsBook.View'
	]
,   function (
	Handlebars,Utils,Code25_CaterpartsGlobal_PartsBook_View
	)
{
	'use strict';

	

	return  {
		mount: function mount (container)
		{
			
			var ProductDetailsFullView = require("ProductDetails.Full.View");
				if (ProductDetailsFullView) {
					
					ProductDetailsFullView.prototype.childViews= _.extend(ProductDetailsFullView.prototype.childViews, {
						"PartsBook": function () {
							
							return new Code25_CaterpartsGlobal_PartsBook_View({
								container: container,custitem_c25_partsbook:this.model.get("item").get("custitem_c25_partsbook")
								,custitem_c25_partsbookpdf:this.model.get("item").get("custitem_c25_partsbookpdf")
								,item:this.model.get("item").get("internalid")
							});
						}
					});

					_.extend(ProductDetailsFullView.prototype, {
						getContext: _.wrap(ProductDetailsFullView.prototype.getContext, function (getContext) {
							var res = getContext.apply(this, _.rest(arguments));

							var custitem_c25_partsbook=this.model.get("item").get("custitem_c25_partsbook");
							var custitem_c25_partsbookpdf=this.model.get("item").get("custitem_c25_partsbookpdf");
							res.partsbook=(!!(custitem_c25_partsbook && custitem_c25_partsbook != "&nbsp;"))||(!!(custitem_c25_partsbookpdf && custitem_c25_partsbookpdf != "&nbsp;"));


							return res;
						})
					})
					
					
					
				}

				var FacetsItemCellView=require("Facets.ItemCell.View");
				if(FacetsItemCellView){

					_.extend(FacetsItemCellView.prototype, {
						getContext: _.wrap(FacetsItemCellView.prototype.getContext, function (getContext) {
							var res = getContext.apply(this, _.rest(arguments));

							var custitem_c25_partsbook=this.model.get("custitem_c25_partsbook");
							var custitem_c25_partsbookpdf=this.model.get("custitem_c25_partsbookpdf");
							res.partsbook=(!!(custitem_c25_partsbook && custitem_c25_partsbook != "&nbsp;"))||(!!(custitem_c25_partsbookpdf && custitem_c25_partsbookpdf != "&nbsp;"));

							return res;
						})
					})

				}

		}
	};
});
